import React from 'react';

const ActionConfirmationModal = ({ 
    isModalOpen, 
    handleClose, 
    handleConfirm, 
    isLoading, 
    title, 
    description, 
    confirmText = 'Confirm', 
    loadingText = 'Processing...', 
    isDanger = false 
}) => {
    if (!isModalOpen) return null;

    return (
        <div 
            className="modal fade show d-block" 
            tabIndex="-1" 
            role="dialog" 
            style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
            onClick={!isLoading ? handleClose : undefined}
        >
            <div 
                className="modal-dialog modal-dialog-centered" 
                role="document" 
                onClick={(e) => e.stopPropagation()}
            >
                <div className="modal-content" style={{ borderRadius: '16px' }}>
                    <div className="modal-header border-0 pb-0 align-items-start position-relative">
                        <h5 className="modal-title fw-bold" style={{ fontSize: '20px', color: '#0f151d', paddingRight: '56px' }}>
                            {title}
                        </h5>
                        <button
                            type="button"
                            className="close plan-change-preview-modal__close position-absolute"
                            onClick={handleClose}
                            disabled={isLoading}
                            style={{ top: '16px', right: '16px', zIndex: 1 }}
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body pt-3">
                        <p className="text-muted mb-0" style={{ fontSize: '15px' }}>
                            {description}
                        </p>
                        <p className="fw-semibold text-dark mb-0 mt-3" style={{ fontSize: '15px' }}>
                            Are you sure you want to continue?
                        </p>
                    </div>
                    <div className="modal-footer border-0 d-flex flex-nowrap pt-0 pb-4 px-4 gap-3">
                        <button
                            type="button"
                            className="btn btn-get-it-now-outline"
                            onClick={handleClose}
                            disabled={isLoading}
                            style={{ flex: 1, width: '100%', padding: '10px 0' }}
                        >
                            Go Back
                        </button>
                        <button
                            type="button"
                            className={`btn ${isDanger ? 'btn-get-it-now-danger' : 'btn-get-it-now'}`}
                            onClick={handleConfirm}
                            disabled={isLoading}
                            style={{ flex: 1, width: '100%', padding: '10px 0' }}
                        >
                            {isLoading ? loadingText : confirmText}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ActionConfirmationModal;
